import React from 'react';
import PropTypes from 'prop-types';
import { useAppContext } from 'context/AppContext';
import { makeStyles } from 'styles/util';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import strings from 'localization/strings';
import { formatAmount } from 'helpers/StringHelper';
import rentalTypes from 'enums/rentalTypes';

import InfoLabel from './InfoLabel';
import Box from '@material-ui/core/Box';

const useStyles = (isMobile, horizontal) => makeStyles(({ theme, styles }) => ({
    areaAndPriceContainer: {
        display: 'flex',
        flexDirection: isMobile || horizontal ? 'row' : 'column',
        flex: '1 1 auto',
        overflow: 'hidden',
        borderTopRightRadius: isMobile || horizontal ? 'initial' : `${styles.borderRadius / 2.5}px`,
        borderBottomRightRadius: `${styles.borderRadius / 2.5}px`,
        borderBottomLeftRadius: isMobile || horizontal ? `${styles.borderRadius / 2.5}px` : 'initial',
        gap: theme.spacing(0.25)
    }
}));

const AreaAndPrice = ({ storageSite, areaAndPriceResult, horizontal = false, forceSmall = false }) => {
    const isMobile = useMediaQuery(theme => theme.breakpoints.down('xs')) || forceSmall;
    const classes = useStyles(isMobile, horizontal)();
    const { appContext } = useAppContext();
    const formattedAmount = `${formatAmount(areaAndPriceResult.displayPrice, areaAndPriceResult.currency, appContext)}/${strings.monthAbbreviated}`;
    const areaExplanation = storageSite.storageGroups.find(sg => sg.rentalType === rentalTypes.customArea.key)
        ? strings.customArea
        : strings.fixedArea;

    return (
        <Box className={classes.areaAndPriceContainer}>
            <InfoLabel
                title={areaExplanation}
                text={areaAndPriceResult.areaString}
                textColor={appContext.colors.areaLabelTextColor}
                backgroundColor={appContext.colors.areaLabelBackgroundColor}
                forceSmall={forceSmall}
            />
            <InfoLabel
                title={areaAndPriceResult.pricePrefix}
                text={formattedAmount}
                textColor={appContext.colors.priceLabelTextColor}
                backgroundColor={appContext.colors.areaLabelBackgroundColor}
                forceSmall={forceSmall}
            />
        </Box>
    );
};

AreaAndPrice.propTypes = {
    storageSite: PropTypes.object.isRequired,
    areaAndPriceResult: PropTypes.object.isRequired,
    horizontal: PropTypes.bool,
    forceSmall: PropTypes.bool
};

export default AreaAndPrice;
